import type { FC } from "react";

import { ConsentCheckbox } from "@jti/ui/components/ContactForm";

import type { formConsentCheckboxListInputs } from "./FormConsentCheckboxList.builder";

type FormConsentCheckboxListProps = BuilderComponentProps<typeof formConsentCheckboxListInputs>;

export const FormConsentCheckboxList: FC<FormConsentCheckboxListProps> = ({ displayConsent, id }) => {
  return <ConsentCheckbox displayConsent={displayConsent} dataTestId={id} />;
};
